// extracted by mini-css-extract-plugin
module.exports = {"root":"GFY_-"};